import { render, staticRenderFns } from "./index.vue?vue&type=template&id=50be62ea&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Nord\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50be62ea')) {
      api.createRecord('50be62ea', component.options)
    } else {
      api.reload('50be62ea', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=50be62ea&", function () {
      api.rerender('50be62ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/atoms/EpiLink/index.vue"
export default component.exports